import { Flow } from '@/components/Flow';
import { ThemeProvider } from '@mui/material/styles';
import { baseTheme } from './config/themes/base-theme';
import { CssBaseline } from '@mui/material';
import { AppHeader } from '@/components/AppHeader';
import { useBranding } from './hooks/use-branding';
import { useEffect } from 'react';
import { ModalProvider } from './contexts/modal/modal-provider';
import { TabListProvider } from './contexts/tabs/tab-list-provider';
import { useFlow } from './hooks/use-flow';

export function App() {
  const { flowStatus, sceneData, partnerBrandingConfig, errorData, errorStatus, init, submit, route } = useFlow();
  const { partnerTheme, setBranding, isPartnerThemeLoading } = useBranding();

  const shouldRenderPartnerTheme = !isPartnerThemeLoading && partnerTheme;

  useEffect(() => {
    if (flowStatus == 'initializing') {
      void init();
    }
  }, [flowStatus, init]);

  useEffect(() => {
    if (isPartnerThemeLoading && partnerBrandingConfig) {
      setBranding(partnerBrandingConfig);
    }
  }, [partnerBrandingConfig, setBranding, isPartnerThemeLoading]);

  return (
    <ThemeProvider theme={shouldRenderPartnerTheme ? partnerTheme : baseTheme}>
      <CssBaseline />
      <ModalProvider>
        <TabListProvider>
          <AppHeader
            route={route}
            submit={submit}
            logoSrc={partnerBrandingConfig?.primary_logo_url}
            components={partnerBrandingConfig?.header_components ?? []}
          />
          <Flow
            flowStatus={flowStatus}
            route={route}
            submit={submit}
            sceneData={sceneData}
            errorData={errorData}
            errorStatus={errorStatus}
          />
        </TabListProvider>
      </ModalProvider>
    </ThemeProvider>
  );
}
